namespace TabAurous.Common {
    export interface CommonAttributeResponse extends Serenity.ServiceResponse {
        AttributeId?: number;
        AttributeCode?: string;
    }
}
